import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const myfirstbackstagepluginPlugin = createPlugin({
  id: 'myfirstbackstageplugin',
  routes: {
    root: rootRouteRef,
  },
});

export const MyfirstbackstagepluginPage = myfirstbackstagepluginPlugin.provide(
  createRoutableExtension({
    name: 'MyfirstbackstagepluginPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
